// import styled from 'styled-components';
// import { FC } from 'react';

// const Card = styled.div`
//   background: linear-gradient(to top left, #ffffff, #f8f9fa);
//   border-radius: 1rem;
//   padding: 2rem;
//   text-align: center;
//   box-shadow: 0 6px 20px rgba(0,0,0,0.1);
//   transition: all 0.3s ease;
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
//   max-width: 300px;
//   min-width: 300px;

//   &:hover {
//     transform: scale(1.03);
//     box-shadow: 0 8px 30px rgba(0,0,0,0.15);
//   }
// `;

// const Title = styled.h2`
//   font-size: 1.25rem;
//   color: #222;
//   margin: 1rem 0 0.5rem;
// `;

// const Description = styled.p`
//   font-size: 0.95rem;
//   color: #555;
//   flex-grow: 1;
// `;

// const TechStack = styled.div`
//   font-size: 0.8rem;
//   // background: #c59c51;
//   color: #6b21a8;
//   // color: linear-gradient(to right, #c59c51, #eab308);
//   padding: 0.4rem 0.8rem;
//   border-radius: 999px;
//   display: inline-block;
//   margin-top: 1rem;
//   font-weight: 600;
// `;

// const AccessButton = styled.a`
//   margin-top: 1.5rem;
//   padding: 0.6rem 1.25rem;
//   background: transparent;
//   color: #6b21a8; /* purple-600 */
//   border: 2px solid #6b21a8;
//   border-radius: 0.5rem;
//   font-weight: 600;
//   font-size: 0.9rem;
//   cursor: pointer;
//   text-decoration: none;
//   transition: all 0.2s ease;

//   &:hover {
//     background-color: #6b21a8;
//     color: white;
//   }
// `;

// interface POCCardProps {
//   poc: {
//     id: string;
//     title: string;
//     description: string;
//     path: string;
//     techStack: string;
//   };
// }

// export const POCCard: FC<POCCardProps> = ({ poc }) => {
//   return (
//     <Card>
//       <div>
//         <Title>{poc.title}</Title>
//         <Description>{poc.description}</Description>
//         <TechStack>{poc.techStack}</TechStack>
//       </div>
//       <AccessButton href={poc.path} target="_blank">
//         Access {poc.id}
//       </AccessButton>
//     </Card>
//   );
// };



// =========================================
// =========================================
// =========================================
// =========================================
// =========================================


import styled from 'styled-components';
import { FC } from 'react';

const CardLink = styled.a`
  background: linear-gradient(to top left, #ffffff, #f8f9fa);
  border-radius: 1rem;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 300px;
  min-width: 300px;
  text-decoration: none;
  color: inherit;

  &:hover {
    transform: scale(1.03);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  }
`;

const Title = styled.h2`
  font-size: 1.25rem;
  color: #222;
  margin: 1rem 0 0.5rem;
`;

const Description = styled.p`
  font-size: 0.95rem;
  color: #555;
  flex-grow: 1;
`;

interface POCCardProps {
  poc: {
    id: string;
    title: string;
    description: string;
    path: string;
    techStack: string;
  };
}

export const POCCard: FC<POCCardProps> = ({ poc }) => {
  return (
    <CardLink href={poc.path} target="_blank" rel="noopener noreferrer">
      <div>
        <Title>{poc.title}</Title>
        <Description>{poc.description}</Description>
        {/* <TechStack>{poc.techStack}</TechStack> */}
      </div>
      {/* Optional: could add subtle indicator like "→" */}
    </CardLink>
  );
};

